import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

type UIAnalyticType = {
	type: string;
	actionSubject: string;
	actionSubjectId: string;
	action: string;
	source: string;
	contentId?: string;
	attributes?: Record<string, string>;
};

const COMPONENT_NAME = 'nudgeTooltip';

export const fireEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	{ contentId, actionSubjectId, actionSubject, source, action, type, attributes }: UIAnalyticType,
) => {
	createAnalyticsEvent({
		type,
		data: {
			actionSubject,
			action,
			actionSubjectId,
			source,
			attributes: {
				...(contentId ? { contentId } : {}),
				nudgeTarget: actionSubjectId,
				componentName: COMPONENT_NAME,
				...attributes,
			},
		},
	}).fire();
};
